import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

class PublishingField extends Component {
  constructor(props) {
    super(props);
    let radioValue;
    if (props.published) {
      radioValue = 'now';
    } else {
      radioValue = 'never';
    }

    this.state = {
      radioValue,
    };
    this.onRadioChange = this.onRadioChange.bind(this);
  }

  onRadioChange(e) {
    const { publishFieldName, change } = this.props;

    switch (e.target.value) {
      case 'now':
        // change(dateFieldName, moment().toISOString());
        change(publishFieldName, true);
        break;
      case 'scheduled':
        change(publishFieldName, true);
        break;
      case 'never':
      default:
        change(publishFieldName, false);
    }

    this.setState({ radioValue: e.target.value });
  }

  render() {
    const { radioValue } = this.state;

    return (
      <div className="publish-options clearfix">
        <div
          className={classnames(
            'form-publish-schedule-option', 'clearfix', radioValue === 'now' && 'form-publish-schedule-option-active',
          )}
        >
          <div
            className="form-publish-schedule-option-button"
          >
            <input
              name="publish"
              type="radio"
              value="now"
              checked={radioValue === 'now'}
              onChange={this.onRadioChange}
            />
          </div>
          <div className="form-publish-schedule-option-content">
            <div className="form-publish-schedule-option-title">Show</div>
            <div className="form-publish-schedule-option-caption">
              The story will be shown on this platform
            </div>
          </div>
        </div>
        <div
          className={classnames(
          'form-publish-schedule-option', 'clearfix', radioValue === 'never' && 'form-publish-schedule-option-active',
          )}
        >
          <div className="form-publish-schedule-option-button">
            <input
              name="publish"
              type="radio"
              value="never"
              checked={radioValue === 'scheduled'}
              onChange={this.onRadioChange}
            />
          </div>
          <div className="form-publish-schedule-option-content">
            <div className="form-publish-schedule-option-title">Don't Show</div>
            <div className="form-publish-schedule-option-caption">
              The story will not be shown on this platform
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PublishingField.propTypes = {
  publishFieldName: PropTypes.string,
  published: PropTypes.bool,
  change: PropTypes.func,
};

const selector = formValueSelector('generic-entry');
function mapStateToProps(state, ownProps) {
  return {
    published: selector(state, ownProps.publishFieldName),
  };
}

export default connect(
  mapStateToProps,
)(PublishingField);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/PublishingField.js